<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { scrollToSlide } from '@/Helpers/scroll.js'

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    cardIndex: {
        type: Number,
        default: undefined,
    },
    logo: {
        type: String,
        default: undefined,
    },
    themeLogoAlign: {
        type: String,
        default: undefined,
    },
    themeLogoSize: {
        type: Number,
        default: undefined,
    },
    scormExport: Boolean,
})

const buttonText = computed(() => {
    // check if browser width is less than 640px
    if (window.innerWidth < 640) {
        return 'Swipe up to get started'
    }
    return props.row.content.buttonText || 'Swipe up to get started'
})

function scrollDown() {
    scrollToSlide(props.cardIndex + 1);
}

const page = usePage()

const logoSrc = computed(() => {
    if (props.scormExport) {
        return props.row.content.logo;
    } else {
        return 'https://' + page.props.s3_bucket + '.s3.' + page.props.s3_region + '.amazonaws.com' + (props.logo !== undefined ? props.logo : props.row.content.logo);
    }
})

const imageSrc = computed(() => {
    if (props.scormExport) {
        return props.row.content.image;
    } else {
        return 'https://' + page.props?.s3_bucket + '.s3.' + page.props?.s3_region + '.amazonaws.com' + props.row.content.image;
    }
})

const logoAlignClass = computed(() => {
    const align = props.row?.content?.logoAlign ?? props.themeLogoAlign ?? 'left';
    if (align === 'center') return 'justify-center';
    if (align === 'right') return 'justify-end';
    return 'justify-start';
})

const logoSize = computed(() => props.row?.content?.logoSize ?? props.themeLogoSize ?? 48)
</script>
<template>
    <div class="relative py-8 flex flex-col h-full w-full">
        <div
            class="mx-4 flex items-center"
            :class="logoAlignClass"
            :style="`height: ${logoSize}px;`"
        >
            <img
                :src="logoSrc"
                alt="Logo"
                class="h-full max-w-full object-contain"
            >
        </div>
        <h1 class="font-black my-4 px-4 text-fl-3xl" :style="'font-family: var(--heading-font, var(--font));'" v-text="row.content.title" />
        <div
            class="grow relative z-10 mt-4 w-full"
            :style="'background-image: url(' + imageSrc + ');background-position: top;background-repeat: no-repeat; background-size: contain;'"
        >
        &nbsp;
        </div>

        <section class="bottomBG w-full relative overflow-x-clip">
            <section
                class="bottomBG absolute -top-12 h-[200%] w-[200%] left-[-50%] rounded-t-[100%] pl-[50%] z-0 vmd:-top-20 vxl:-top-24"
            />
            <section class="z-10 relative flex flex-col flex-nowrap justify-evenly h-full">
                <h2 class="text-fl-2xl font-black px-4" :style="'font-family: var(--heading-font, var(--font));'" v-text="row.content.subtitle" />
                <p class="px-4 py-2 text-fl-lg" v-text="row.content.tertiary" />
                <div class="flex flex-col w-full">
                    <button
                        type="button"
                        class="place-self-end rounded-full 
                    px-fl-4 
                    py-fl-2 
                    mr-4
                    font-bold 
                    shadow-sm 
                    border-2
                    focus-visible:outline 
                    focus-visible:outline-2 
                    focus-visible:outline-offset-2 
                    focus-visible:outline-white"
                        @click="scrollDown"
                        v-text="buttonText"
                    />
                </div>
            </section>
        </section>
    </div>
</template>

<style scoped>
button {
    background-color: var(--button_hover_bg);
    color: var(--button_hover_text);
    border-color: var(--button_hover_bg);
}

button:hover {
    color: var(--button_text);
    background-color: var(--button_bg);
}

.bottomBG {
    background-color: var(--button_bg);
    color: var(--button_text);
}
</style>